import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { videos } from "@/mocks/videos";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestVideos from "@/pages/home/components/LatestVideos";
import HotRanking from "@/pages/home/components/HotRanking";
import AboutIntro from "@/pages/home/components/AboutIntro";

export default function Home() {
  useDocumentTitle(
    "啪啪视频 - 高清在线视频分享平台",
    "啪啪视频提供丰富多样的在线视频资源，涵盖娱乐、生活、教育等多个类别，支持用户在线浏览和分享精彩视频内容。",
    "啪啪视频,在线视频,视频分享,高清视频,视频平台,娱乐视频,视频大全",
  );

  return (
    <div className="w-full pb-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 pt-6 md:px-6">
        <HeroCarousel />
      </div>

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">视频分类</h2>
            <p className="mt-1 text-sm text-foreground-500">按兴趣挑选类别，快速进入你想看的内容世界。</p>
          </div>
          <Link
            to="/search"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700"
          >
            全部分类视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <CategoryGrid />
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新上传</h2>
            <p className="mt-1 text-sm text-foreground-500">刚刚上线的精彩视频，第一时间为你呈现。</p>
          </div>
          <Link
            to="/search"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <LatestVideos videos={videos} />
      </section>

      <section className="mt-14 border-y border-background-200 bg-background-100 py-12 md:py-16">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
          <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
            <div>
              <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-fire-line"></i>
                本周热榜
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门视频榜单</h2>
              <p className="mt-1 text-sm text-foreground-500">根据播放量排序，看看大家都在看什么。</p>
            </div>
          </div>
          <HotRanking videos={videos} />
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 pt-14 md:px-6">
        <AboutIntro />
      </section>
    </div>
  );
}